import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Button from '../../CommonComponents/Button';
import { InputV2 } from '../../CommonComponents/InputV2/InputV2';
import Modal from '../../CommonComponents/Modal';
import { FormErrorMessages, FormRegex } from '../../constants';
import './AddTenantModal.scss';

interface IProps {
  clientName: string;
  imageUrl: string;
  closeModal: Function;
  submitForm: Function;
  existingAdminEmailList: string[];
  tenantId: number;
  tenantAdminErrorMessage?: string;
  onResetErrorMessage: Function;
  buttonTitle: {
    addAdmin: string;
    confirmAdmin: string;
  };
  tenantAdminProcessing: boolean;
}

const AddTenantModal = (props: IProps) => {
  const validationSchema = Yup.object().shape({
    userEmail: Yup.string()
      .email(FormErrorMessages.email.inValid)
      .required(FormErrorMessages.email.required)
      .notOneOf(
        props.existingAdminEmailList || [],
        FormErrorMessages.tenantAdmin.alreadyAdded
      ),
    firstName: Yup.string()
      .matches(new RegExp(FormRegex.firstName), FormErrorMessages.firstName.inValid)
      .required(FormErrorMessages.firstName.required),
    lastName: Yup.string()
      .matches(new RegExp(FormRegex.lastName), FormErrorMessages.lastName.inValid)
      .required(FormErrorMessages.lastName.required),
  });
  // setFieldValue('continueAfter', true);
  // props.submitForm({ ...values, continueAfter: true }, setSubmitting);
  return (
    <Modal
      title='Add tenant admin'
      isOpen={true}
      onClose={props.closeModal}
      style={{
        height: '100vh',
        padding: '8px 0px 30px 30px',
      }}
      //   disableCloseButton={props.tenantAdminProcessing}
    >
      <div className='existing-admins-add-more'>
        {/* <div className="ea-add-more-header">Add tenant admin</div> */}
        <Formik
          initialValues={{
            continueAfter: false,
            firstName: '',
            lastName: '',
            tenantId: props.tenantId,
            userEmail: '',
            userId: 0,
            agentId: sessionStorage.getItem('agentId'),
          }}
          validateOnMount={true}
          validationSchema={validationSchema}
          onSubmit={() => {}}
          render={({
            values,
            setFieldValue,
            isSubmitting,
            isValid,
            errors,
            setSubmitting,
          }) => {
            return props.tenantAdminErrorMessage ? (
              <ErrorDuringAddingTenantAdmin
                message={props.tenantAdminErrorMessage}
                onSubmit={props.closeModal}
                onClose={props.closeModal}
                onBack={props.onResetErrorMessage}
                buttonTitle={props.buttonTitle}
                tenantAdminProcessing={props.tenantAdminProcessing}
              />
            ) : (
              <div className='form-wrapper'>
                <InputV2
                  placeholder='Email'
                  title='Email'
                  value={values.userEmail}
                  onChange={(value: any) => setFieldValue(`userEmail`, value)}
                  className='form-input'
                  required={true}
                  id='userEmail'
                  validationFailureMessage={errors.userEmail}
                />

                <InputV2
                  placeholder='First Name'
                  title='First Name'
                  value={values.firstName}
                  onChange={(value: any) => setFieldValue('firstName', value)}
                  className='form-input'
                  required={true}
                  id='firstName'
                  validationFailureMessage={errors.firstName}
                />
                <InputV2
                  placeholder='Last Name'
                  title='Last Name'
                  value={values.lastName}
                  onChange={(value: any) => setFieldValue('lastName', value)}
                  // styles={{ marginBottom: '31px' }}
                  id='lastName'
                  required={true}
                  validationFailureMessage={errors.lastName}
                />
                <div>
                  <div className='create-tenant-modal-footer'>
                    <div className='button-div'>
                      <div className='cancel-button'>
                        <Button
                          text='Cancel'
                          theme='secondary-blue'
                          onClick={props.closeModal}
                          disabled={props.tenantAdminProcessing}
                        />
                      </div>
                      <div>
                        <Button
                          text={props.buttonTitle.addAdmin}
                          theme='dark'
                          onClick={() => props.submitForm(values, setSubmitting)}
                          disabled={
                            !isValid || isSubmitting || props.tenantAdminProcessing
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }}
        />
      </div>
    </Modal>
  );
};

export default AddTenantModal;

const ErrorDuringAddingTenantAdmin = (props: {
  message: string;
  onSubmit: Function;
  onClose: Function;
  onBack: Function;
  buttonTitle: {
    confirmAdmin: string;
  };
  tenantAdminProcessing: boolean;
}) => {
  return (
    <Modal
      // title='Existing user account'
      title='User already added'
      onClose={props.onClose}
      isOpen={true}
      //   disableCloseButton={props.tenantAdminProcessing}
    >
      <div className='tenant-admin-exists-w'>
        {/* <div>Existing user account</div> */}
        <div className='add-tenant-error'>{props.message}</div>
        <div className='existing-user-buttons-container'>
          {/* <div>
            <Button
              text='Cancel'
              onClick={props.onBack}
              theme='secondary-blue'
              disabled={props.tenantAdminProcessing}
            />
          </div> */}
          {/* <div>
            <Button
              disabled={props.tenantAdminProcessing}
              text={props.buttonTitle.confirmAdmin}
              onClick={() => props.onSubmit(true)}
              theme='dark-blue'
            />
          </div> */}
          <div>
            <Button
              text='Okay'
              onClick={props.onClose}
              theme='secondary-blue'
              disabled={props.tenantAdminProcessing}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
